import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Overview from "@/pages/Overview";
import Reputation from "@/pages/Reputation";
import ContentStudio from "@/pages/ContentStudio";
import ImageStudio from "@/pages/ImageStudio";
import SeoEngine from "@/pages/SeoEngine";
import Calendar from "@/pages/Calendar";
import Profile from "@/pages/Profile";
import Billing from "@/pages/Billing";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { BlogIndex, BlogArticle } from "@/pages/Blog";
import PublicProfile from "@/pages/PublicProfile";
import Social from "@/pages/Social";
import Network from "@/pages/Network";
import Monitoring from "@/pages/Monitoring";
import Landing from "@/pages/Landing";

function RootGate() {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground font-mono text-sm">
        Initializing…
      </div>
    );
  if (!user) return <Landing />;
  return <Layout />;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster theme="dark" position="top-right" richColors />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/network" element={<Network />} />
              <Route path="/p/:slug" element={<PublicProfile />} />
              <Route
                path="/"
                element={<RootGate />}
              >
                <Route index element={<Overview />} />
                <Route path="reputation" element={<Reputation />} />
                <Route path="monitoring" element={<Monitoring />} />
                <Route path="content" element={<ContentStudio />} />
                <Route path="images" element={<ImageStudio />} />
                <Route path="seo" element={<SeoEngine />} />
                <Route path="social" element={<Social />} />
                <Route path="calendar" element={<Calendar />} />
                <Route path="profile" element={<Profile />} />
                <Route path="billing" element={<Billing />} />
                <Route path="admin" element={<Admin />} />
                <Route path="payment/success" element={<PaymentSuccess />} />
                <Route path="payment/cancel" element={<PaymentCancel />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
